import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { BrandContext } from '../context/BrandContext';
import { Spinner } from './ui';

export default function BrandGuard({ children }) {
  const { profileExists, loading, error } = useContext(BrandContext);
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 32, display: 'flex', justifyContent: 'center' }}>
        <Spinner label="Loading your brand workspace" />
      </div>
    );
  }

  if (error && error !== 'brand_profile_unavailable') {
    return (
      <div style={{ padding: 32 }}>
        <h2 style={{ marginBottom: 8 }}>Brand workspace unavailable</h2>
        <p style={{ color: 'var(--color-text-muted)' }}>
          {error}. Please retry or contact support if this persists.
        </p>
      </div>
    );
  }

  if (!profileExists) {
    return <Navigate to="/brand" replace state={{ from: location }} />;
  }

  return children;
}
